import { useState } from "react";
import { ReactComponent as CheckIcon } from "../../Assets/check-sharp-solid.svg";
import { executeAIAction } from "./aiActionHandler";
import "./AIActionButton.scss";

const ActionButton = ({ action, index }: { action: any; index: number }) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    if (clicked) {
      return;
    }
    setClicked(true);
    executeAIAction(action);
  };

  return (
    <button
      key={index}
      className="ai-action-button"
      onClick={handleClick}
      disabled={clicked}
    >
      {action?.actionButtonTitle}
      {clicked && <CheckIcon />}
    </button>
  );
};

export default ActionButton;
